export const ERRORS = {
  '400': 'El código de promoción no es válido.',
  '401': 'El correo del tutor no está verificado.',
  '412': 'Algún alumno no está vinculado al tutor.',
};
